import { SearchOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Button, Flex, Input } from 'antd';

import { MultipleSelect } from '@app/components';
import { PF } from '@app/pages/Warehouses/ProductDirectory/data';
import type { FiltersType } from '@app/pages/Warehouses/ProductDirectory/types';
import { getSelectedOptions } from '@app/pages/Warehouses/utils';

const FILTERS = `${PF}_filters`;

export const Filters: FiltersType = ({
  onChangeSearchTerm,
  values: { SearchTerm, BrandIds, CategoryIds },
  skipFilters,
  onFilterChange,
  onSearch,
  disabledFilters,
  categoryOptions,
  brandsOptions,
}) => (
  <div className={`${FILTERS}_container`}>
    <Input
      addonBefore={<SearchOutlined />}
      placeholder="Введите название, штрихкод или артикул товара"
      className={`${FILTERS}_search`}
      value={SearchTerm || ''}
      onChange={onChangeSearchTerm}
      onPressEnter={onSearch}
      disabled={disabledFilters}
    />

    <Flex wrap="wrap" gap={12} className={`${FILTERS}_toolbar`}>
      <MultipleSelect
        className={`${FILTERS}_select`}
        placeholder="Все категории"
        allOptions={categoryOptions}
        selectedOption={getSelectedOptions(categoryOptions, CategoryIds)}
        setSelectedOptions={(values) => onFilterChange('CategoryIds', values)}
        disabled={disabledFilters}
      />
      <MultipleSelect
        className={`${FILTERS}_select`}
        placeholder="Все бренды"
        allOptions={brandsOptions}
        selectedOption={getSelectedOptions(brandsOptions, BrandIds)}
        setSelectedOptions={(values) => onFilterChange('BrandIds', values)}
        disabled={disabledFilters}
      />
      <div className={`${FILTERS}_buttons`}>
        <Button
          htmlType="reset"
          onClick={skipFilters}
          className={`${FILTERS}_buttons_item`}
          disabled={disabledFilters}
        >
          <CloseCircleOutlined />
          Сброс
        </Button>
        <Button
          type="primary"
          onClick={onSearch}
          className={`${FILTERS}_buttons_item`}
          disabled={disabledFilters}
        >
          Показать
        </Button>
      </div>
    </Flex>
  </div>
);
